"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookie = exports.hasInvalidDomainLoginOptionError = exports.getCookie = exports.anonymousUserId = void 0;
var _v = _interopRequireDefault(require("uuid/v4"));
var _get = _interopRequireDefault(require("lodash/get"));
var _first = _interopRequireDefault(require("lodash/first"));
var _constants = require("../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// returns ajs_anonymous_id cookie value
var anonymousUserId = exports.anonymousUserId = function anonymousUserId() {
  var pair = document.cookie.match(new RegExp('ajs_anonymous_id=([^;]+)'));
  if (pair) {
    var uuid = decodeURI(pair[1]).replace(/"/g, '');
    return uuid;
  }
  var id = (0, _v["default"])();
  setCookie('ajs_anonymous_id', id, 730);
  return id;
};
var setCookie = exports.setCookie = function setCookie(cookieName, cookieValue, expireDays) {
  var expires = '';
  if (expireDays) {
    var d = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    expires = "expires=".concat(d.toUTCString(), ";");
  }
  document.cookie = "".concat(cookieName, "=").concat(cookieValue, ";").concat(expires, "path=/");
};
var getCookie = exports.getCookie = function getCookie(cookieName) {
  var b = document.cookie.match("(^|;)\\s*".concat(cookieName, "\\s*=\\s*([^;]+)"));
  return b ? b.pop() : '';
};
var hasInvalidDomainLoginOptionError = exports.hasInvalidDomainLoginOptionError = function hasInvalidDomainLoginOptionError(graphQLErrors) {
  return (0, _get["default"])((0, _first["default"])(graphQLErrors), 'extensions.code') === _constants.INVALID_LOGIN_OPTION_CODE;
};
//# sourceMappingURL=data-utils.js.map